import { AddDeliveryLocation } from '../../redux-toolkits/products/products.type'
import { ActionChip } from '../cards/actionChip'

export const ProductLocationChips = ({
  locations,
  emptyText,
  editable = false,
  onEdit,
  onRemove,
}: {
  locations: AddDeliveryLocation[]
  emptyText: string
  editable?: boolean
  onEdit?: (index: number, item: AddDeliveryLocation) => void
  onRemove?: (index: number) => void
}) => {
  if (locations.length < 1) {
    return <p className="text-sm text-sec-black">{emptyText}</p>
  }

  return (
    <div className="flex flex-row flex-wrap items-center gap-4">
      {locations.map((item, idx) => {
        const locationAction =
          item.locationType === 'pickup' ? 'Delivers from' : 'Delivers to'
        const deliveryTime = item.deliveryTime ? ` in ${item.deliveryTime}` : ''

        return (
          <ActionChip
            key={`${item.locationId}-${idx}`}
            name={
              <p>
                {locationAction} {item.locationName}
                <span className="font-medium">{deliveryTime}</span>
              </p>
            }
            onClick={
              editable && item.locationType !== 'pickup'
                ? () => {
                    onEdit?.(idx, item)
                  }
                : undefined
            }
            onDismiss={
              editable && item.locationType !== 'pickup'
                ? () => {
                    onRemove?.(idx)
                  }
                : undefined
            }
          />
        )
      })}
    </div>
  )
}
